import { PlayerWithState } from '../modules/state';
import { PlayerWithProperties } from '../modules/property';
import { PlayerWithEvents } from '../modules/event';
import { PlayerWithPositionListener } from '../modules/position-listener';
import { PlayerWithError } from '../modules/error';
export const PlayerWithZapiBase = (Base) => {
    return PlayerWithPositionListener(PlayerWithError(PlayerWithEvents(PlayerWithProperties(PlayerWithState(Base)))));
};
